import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const CREATE_NEW_INSTALLMENT =
  FORM_FIELDS.PROVIDENT_FUND.CREATE_NEW_INSTALLMENT;

export const addNewInstallmentValidation = yup.object().shape({
  [CREATE_NEW_INSTALLMENT.INSTALLMENT_AMOUNT]: yup
    .number()
    .typeError("Loan amount has to be a number")
    .required("Loan amount is required"),
  [CREATE_NEW_INSTALLMENT.INSTALLMENT_FILE_NAME]: yup
    .string()
    .required("File is required"),
  [CREATE_NEW_INSTALLMENT.INSTALLMENT_DATE]: yup
    .string()
    .required("Date is required"),
  [CREATE_NEW_INSTALLMENT.DOCUMENT]: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number(),
        name: yup.string(),
        mimeType: yup.string(),
        fileId: yup.string(),
        documentId: yup.string(),
        documentType: yup.string(),
      }),
    )
    .nullable()
    .required("Document is required"),
});

export type AddNewInstallmentFormDataType = yup.InferType<
  typeof addNewInstallmentValidation
>;
